(function (app, ng) {

    app.directive("scrollableTbody",
        [
            function () {
                return {
                    restrict: "A",
                    link: function (scope, element) {
                        element.bind("scroll",
                            function () {
                                ng.forEach(element.children(),
                                    function (child) {
                                        ng.element(child).css("width", element.innerWidth() + element.scrollLeft());
                                    });
                            });
                    }
                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line